import React, { useCallback } from 'react'
import formStyles from 'modules/Forms/common-form.module.scss'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import { Button } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import { useLocalStorage } from 'utils/hooks/useLocalStorage'

const SubmitButtons = ({
  submitting = false,
  onClose = () => {},
  className = '',
  submitted = false,
  formName = null,
}) => {
  const { t } = useTranslation()
  const [, setAccountConfig] = useLocalStorage('CreateAccountConfig', {})
  const [, setAdvertiserPresetConfig] = useLocalStorage('CreateAccountAdvertiserPresetConfig', {})
  const [, setFillingTypeConfig] = useLocalStorage('CreateAccountFillingTypeConfig', {})

  const handleClick = useCallback(() => {
    setAccountConfig({ [formName]: null })
    setAdvertiserPresetConfig({ [formName]: null })
    setFillingTypeConfig({ [formName]: null })
    onClose({ confirm: false })
  }, [onClose])

  return (
    <div className={clsx(formStyles['formControl__action-buttons'], className, 'margin-top-48')}>
      {submitted ? (
        <Button
          fullWidth
          onClick={handleClick}
          variant="primary"
          size="l"
          type="button"
        >
          {t('common::form_buttons.goToAccounts')}
        </Button>
      ) : (
        <>
          <Button
            disabled={submitting}
            onClick={onClose}
            variant={'ghost'}
            grey
            size="l"
            type="button"
            color={'Label-Fifth'}
            fullWidth
          >
            {t('common::form_buttons.cancel')}
          </Button>

          <Button
            disabled={submitting}
            size="l"
            variant="primary"
            type="submit"
            fullWidth
          >
            {t('services::forms.register_account.submit_button')}
          </Button>
        </>
      )}
    </div>
  )
}

SubmitButtons.propTypes = {
  submitting: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  className: PropTypes.string,
  submitted: PropTypes.bool,
  formName: PropTypes.string,
}

export default SubmitButtons
